import { useEffect, useState } from "react";
import Loader from "./Loader";
import Drower from "./Drower";

function Form(props) {
  const [display, setDisplay] = useState(false)
  const [visibleHelp, setVisibleHelp] = useState(false)
  const [visibleResult, setVisibleResult] = useState(false)
  const [result, setResult] = useState(0)
  const [inputValue, setInputValue] = useState({})
  const [riskValue, setRiskValue] = useState(0.1)

  let listRisk = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.2, 4.3, 4.4, 4.5, 4.6, 4.7, 4.8, 4.9, 5.0]

  const onFinish = (e) => {
    e.preventDefault()
    setDisplay(true);
    let price = e.target[0].value;
    let stop = e.target[1].value;
    let balance = e.target[2].value;
    let leverage = e.target[3].value;
    let risk = riskValue;
    let a = ((balance * 0.01) * risk);
    let volume = a / (Math.abs(price - stop) * leverage)
    let val = Number(volume).toFixed(20)
    setTimeout(() => {
      setInputValue({
        'price': price,
        'stop': stop,
        'balance': balance,
        'leverage': leverage,
        'risk': risk,
      })
      setDisplay(false)
      setResult(volume);
      setVisibleResult(true)
    }, 2000)
  }


  return (
    <>
      {display && <Loader />}
      <form onSubmit={onFinish} className="form">
        <div onClick={() => { setVisibleHelp(true) }} className="form-help">
          {localStorage.getItem('language') == 'fa' ? 'چگونه استفاده کنیم ؟' : 'How to use ?'}
        </div>

        <div className="form-item">
          <span>{localStorage.getItem('language') == 'fa' ? 'قیمت خرید' : 'Price '}</span>
          <img src='/assets/svg/stop.svg' alt="svg" />
          <input type={'number'} required step={0.1} />
        </div>

        <div className="form-item">
          <span>{localStorage.getItem('language') == 'fa' ? 'نقطه استاپ' : 'Stop'}</span>
          <img src='/assets/svg/dollar.svg' alt="svg" />
          <input type={'number'} required step={0.1} />
        </div>

        <div className="form-item">
          <span>{localStorage.getItem('language') == 'fa' ? 'کل سرمایه' : 'Balance'}</span>
          <img src='/assets/svg/balance.svg' alt="svg" />
          <input type={'number'} required step={0.1} />
        </div>

        <div className="form-item">
          <span>{localStorage.getItem('language') == 'fa' ? ' اهرم' : 'Leverage'}</span>
          <img src='/assets/svg/power.svg' alt="svg" />
          <input type={'number'} required step={0.1}/>
        </div>

        <div className="form-item">
          <span>{localStorage.getItem('language') == 'fa' ? 'ریسک به سرمایه' : 'Risk per Balance '} %</span>
          <img src='/assets/svg/risk.svg' alt="svg" />
          <input type={'number'} value={riskValue} onChange={(e) => { setRiskValue(e.target.value) }} required />
          <div className="form-item-counter">
            <div className="form-item-counter-item" onClick={() => { setRiskValue((+riskValue + 0.1).toFixed(1)) }}>
              <img src='/assets/svg/up-arrow.svg' alt="svg" />
            </div>
            <div className="form-item-counter-item" onClick={() => { setRiskValue((+riskValue - 0.1).toFixed(1)) }}>
              <img src='/assets/svg/down-arrow.svg' alt="svg" />
            </div>
          </div>
        </div>

        <div className="form-sub">
          <button>{localStorage.getItem('language') == 'fa' ? 'محاسبه' : 'Calculator '}</button>
        </div>

        <Drower name={'Result'} title={'show-p-result'} visible={visibleResult} setVisible={setVisibleResult}>
          <div className="result">

            <div className="result-item">
              <div className="result-item-section">{localStorage.getItem('language') == 'fa' ? 'قیمت خرید' : 'Price'}</div>
              <div className="result-item-section english_font">{inputValue.price}</div>
            </div>

            <div className="result-item">
              <div className="result-item-section">{localStorage.getItem('language') == 'fa' ? 'نقطه استاپ' : 'Stop'}</div>
              <div className="result-item-section english_font">{inputValue.stop}</div>
            </div>

            <div className="result-item">
              <div className="result-item-section">{localStorage.getItem('language') == 'fa' ? ' کل سرمایه' : 'Balance'}</div>
              <div className="result-item-section english_font">{inputValue.balance}</div>
            </div>

            <div className="result-item">
              <div className="result-item-section">{localStorage.getItem('language') == 'fa' ? ' اهرم' : 'Leverage'}</div>
              <div className="result-item-section english_font">{inputValue.leverage}</div>
            </div>

            <div className="result-item">
              <div className="result-item-section">{localStorage.getItem('language') == 'fa' ? ' ریسک' : 'Risk'}</div>
              <div className="result-item-section english_font">{inputValue.risk}</div>
            </div>

            <div className="result-item-finall">
              <div className="result-item-finall-section">{localStorage.getItem('language') == 'fa' ? ' حجم مجاز خرید' : 'Permitted purchase volume'}</div>
              <div className="result-item-finall-section result-item-finall-section-res" >{result}</div>
            </div>

          </div>
          <div className="drower-close" onClick={() => { setVisibleResult(false) }}>Close</div>

        </Drower>

        <Drower name={'Help'} title={'show-p-help'} visible={visibleHelp} setVisible={setVisibleHelp}>
          {localStorage.getItem('language') == 'fa' ?
            <div className="help-des">
              <span>1 - در قسمت بالانس موجودی خود را وارد کنید .</span>
              <span>2 - در قسمت ریسک به سرمایه (مقدار ریسکی که میخواهید به سرمایه خود وارد کنید) را انتخاب نمایید .</span>
              <span><span className="help-des-title">نکته  </span> - طبق تجربه ما ماکزیمم ریسکی که به سرمایه وارد میکنید بین 0.5 تا 2 باشد. </span>
              <span><span className="help-des-title">نکته  </span> - مخصوصا در سال های اول معامله گری بهتر است بین 0.5 تا 1 باشد. </span>
              <span>پس ریسک به سرمایه را همیشه بین  0/5 تا 1 انتخاب کنید .</span>
              <span>در قسمت Stop عدد استاپ خود را وارد کنید</span>
              <span>در قسمت enter price عدد قیمت ورودی خود را وارد کنید</span>
              <span>اگر از معاملات اهرم دار استفاده میکنید لوریج را روی اهرم خود قرار دهید.</span>
              <span>اگر از معاملات اسپات استفاده می کنید لوریج را روی یک قرار دهید.</span>
              <span><span className="help-des-title">نکته  </span> - بیش از 3 معامله باز نداشته باشید. </span>
            </div>
            :
            <div className="help-des" style={{ direction: 'ltr' }}>
              <span>Enter your account credit in the balance field</span>

              <span>In reward/risk section: Write down the amount of risk you want to put into your funds.</span>

              <span>*Recommendation : If you are a professional investor, adjust your risk between 0.5 and 2.0 and</span>

              <span>If you are an amateur investor, adjust your risk between 0.5-1.0</span>

              <span>*Seggestion: limited your risk among 0.5 to 1.0 .</span>

              <span>Enter your stop number in the Stop Loss field.</span>

              <span>Enter your value in Price field.</span>

              <span>IF you use leverage trading, set your ideal leverage.</span>

              <span>IF you use spot trading set your leverage on one.</span>

              <span>Note: Do not have more than three open trade (Over trading results in tiredness and losing your asset.)</span>
            </div>
          }
          <div className="drower-close" onClick={() => { setVisibleHelp(false) }}>Close</div>
        </Drower>

      </form>
    </>
  );
}

export default Form;